import React from 'react';

import OrderSim from '../../ordersim/OrderSim';

export const OrderSimScreen = () => {
  return (
    <OrderSim/>
  );
}

export default OrderSimScreen;
